var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.list),function(item,index){return _c('a-tag',{key:index,staticStyle:{"margin-bottom":"4px"},attrs:{"color":"cyan"}},[_vm._v(" "+_vm._s(item.appname + '-' + item.appcode)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }